module.exports = __webpack_public_path__ + "img/06.7fd13c8e.jpg";